import { useTheme } from '@mui/material';
import { toast } from 'react-toastify';

const useToast = () => {
	const themeUtils = useTheme();
	const popToast = (message: string) => {
		toast(message, {
			position: 'bottom-center',
			autoClose: 3000,
			pauseOnHover: true,
			style: {
				background: themeUtils.palette.primary.main,
				color: themeUtils.palette.common.white,
			},
		});
	};

	return popToast;
};

export default useToast;
